$(document).ready(function () {
  if ($('body').hasClass('homepage') && !$('body').hasClass('neos-backend')) {
    var mainMenuScrollSpy = function () {
      var mainMenu = $('.main-menu'),
          mainMenuHeader = mainMenu.find('.navbar-header');
          menuClassToToggle = 'navbar-fixed-top',
          prevSibling = mainMenu.prev(),
          nextSibling = mainMenu.next(),
          nextSiblingInitialMargin = nextSibling.css('margin-top'),
          threshold = 0;

      $(window).on('load resize', function() {
        threshold = prevSibling.offset().top + prevSibling.outerHeight();
      }());

      $(window).on('scroll', function() {
        if ($(window).scrollTop() > threshold) {
          mainMenu.addClass(menuClassToToggle);
          nextSibling.css('margin-top', mainMenu.outerHeight());
        } else {
          mainMenu.removeClass(menuClassToToggle);
          nextSibling.css('margin-top', nextSiblingInitialMargin);
        }
      });

      mainMenu.find('.navbar-collapse').on('shown.bs.collapse', function() {
        var mainMenuWindowOffsetBottom = mainMenuHeader.get(0).getBoundingClientRect().top + mainMenuHeader.height();

        if (mainMenuWindowOffsetBottom >= $(window).height()) {
          $('html, body').stop().animate({
            scrollTop: mainMenuWindowOffsetBottom - mainMenu.height()
          }, 600);
        }
      });
    }();
  }

  $('.main-menu .dropdown').on('show.bs.dropdown', function() {
    $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
  });

  $('.main-menu .dropdown').on('hide.bs.dropdown', function() {
    $(this).find('.dropdown-menu').first().stop(true, true).slideUp(0);
  });
});
